/**
 * How to Use featureToggle
 * import featureToggle, { MARGIN_TRADING } from '@config/featureToggle';
 *
 * const Component = () => {
 *    const featMarginTrading = featureToggle.some(
 *        feat => feat.feature === MARGIN_TRADING && feat.toggle
 *    );
 *
 *    return featMarginTrading ? <div>Fitur On</div> : <div>Fitur Off</div>;
 * }
 */

export const MARGIN_TRADING = 'MARGIN_TRADING';
export const DAY_TRADING = 'DAY_TRADING';
export const STOCK_REVAMP = 'STOCK_REVAMP';

export default [
  { feature: MARGIN_TRADING, toggle: true },
  { feature: DAY_TRADING, toggle: true },
  { feature: STOCK_REVAMP, toggle: false },
];
